import ErpQueueCard from './ErpQueueCard';

export default ErpQueueCard;